import React from 'react';

const DependenciesRightArrow = props => (
	<svg className={props.class ? `${props.class} dependencies-right-arrow` : 'dependencies-right-arrow'} xmlns="http://www.w3.org/2000/svg" width="4" height="9" viewBox="0 0 4 9">
		<path fill={props.color ? props.color : 'black'} fillRule="evenodd" d="M0 8.499l4-4L0 .5z" />
	</svg>
);

export default DependenciesRightArrow;
